var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.45,
    height: 19.467,
    viewBox: "243.633 69.617 18.45 19.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253 79.852c2.485 0 4.5-1.89 4.5-4.222 0-2.333-2.015-4.223-4.5-4.223s-4.5 1.89-4.5 4.223c0 2.331 2.015 4.222 4.5 4.222Zm0 1.407c-3.313 0-6-2.52-6-5.63s2.687-5.63 6-5.63c3.314 0 6 2.52 6 5.63s-2.686 5.63-6 5.63Zm7.5 7.037v-2.11c0-1.167-1.007-2.112-2.25-2.112h-10.5c-1.243 0-2.25.945-2.25 2.111v2.111c0 .389-.335.704-.75.704-.414 0-.75-.315-.75-.704v-2.11c0-1.944 1.68-3.52 3.75-3.52h10.5c2.071 0 3.75 1.576 3.75 3.52v2.11c0 .389-.335.704-.75.704-.414 0-.75-.315-.75-.704Z",
    fill: "#1785d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 79.852c2.485 0 4.5-1.89 4.5-4.222 0-2.333-2.015-4.223-4.5-4.223s-4.5 1.89-4.5 4.223c0 2.331 2.015 4.222 4.5 4.222Zm0 1.407c-3.313 0-6-2.52-6-5.63s2.687-5.63 6-5.63c3.314 0 6 2.52 6 5.63s-2.686 5.63-6 5.63Zm7.5 7.037v-2.11c0-1.167-1.007-2.112-2.25-2.112h-10.5c-1.243 0-2.25.945-2.25 2.111v2.111c0 .389-.335.704-.75.704-.414 0-.75-.315-.75-.704v-2.11c0-1.944 1.68-3.52 3.75-3.52h10.5c2.071 0 3.75 1.576 3.75 3.52v2.11c0 .389-.335.704-.75.704-.414 0-.75-.315-.75-.704Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    stroke: "#1785d6",
    fill: "transparent"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.025c60f5ff15dc8a521d5d149aaf90ec.svg";
export { ForwardRef as ReactComponent };